'use strict';

var App = require('app');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var OOP = require('utils/oop');

module.exports = OOP.extend(Marionette.ItemView, {
    template: require('components/profile/templates/label_pool_dialog'),

    initialize: function (options) {
        this.origItems = Array.prototype.concat(this.model.get('pool'), []);
        // add pool
        var labels = this.model.get('labels');
        Misc.selectWhere(this.origItems, function (x) {
            return !labels.includes(x);
        }).forEach(function (x) {
            labels.push(x);
        });
        Misc.sortStrings(labels);
    },

    ui: OOP.inheritedObj('ui', {
        tbNewLabel: 'input.js-new-label',
        btnAdd: 'button.js-btn-add',
        btnsave: 'button#js-save',
        ddlPool: 'select#msel-pool',
    }),

    events: OOP.inheritedObj('events', {
        'keyup input.js-new-label': function (e) {
            if (e.keyCode == 13) {
                this.addNewItem();
            }
            var l = this.ui.tbNewLabel.val().trim();
            this.model.set('newitem', l);
            Misc.setDisabled(this.ui.btnAdd, !l || !l.length);
        },
        'click button.js-btn-add': function () {
            this.addNewItem();
        },
        'click button#js-save': function () {
            this.save();
        },
        'change select#msel-pool': function () {
            this.model.set('pool', this.ui.ddlPool.val() || []);
            this.render();
        },
    }),

    addNewItem: function () {
        var self = this;
        var addToArray = function (ar) {
            var newItem = self.model.get('newitem');
            if (!ar.includes(newItem)) {
                ar.push(newItem);
                Misc.sortStrings(ar);
            }
        };

        addToArray(this.model.get('pool'));
        addToArray(this.model.get('labels'));
        this.model.set('newitem', '');
        this.render();
    },

    save: function () {
        var self = this;
        this.model.set('errors', undefined);

        $.when(
            App.request('label:pool:save', this.model.get('pool')).done(function (err) {
                if (err) {
                    self.model.set('errors', err);
                    self.render();
                    return;
                }

                self.options.cb();
                App.hideModal();
                return;
            })
        );
    },

    serializeData: function () {
        var data = this.base.serializeData();
        data.canSave = this.model.get('pool').length > 0;
        data.canAdd = this.model.get('newitem') && this.model.get('newitem').trim().length > 0;
        return data;
    },

    initMultiSelect: function () {
        Misc.initializeMultiSelect('#msel-pool', I18N.TR('Verfügbar'), I18N.TR('Labels'), true);
    },

    onRender: function () {
        this.initMultiSelect();
    },

    onShow: function () {
        this.initMultiSelect();
    },
});
